import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import styles from "./Add.module.scss";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";

import MessageBox from "components/MessageBox/MessageBox";
import Modal from "components/Modal/Modal";
import modalStyles from "components/ConfirmationModal/ConfirmationModal.module.scss";
// import Checkbox from "components/Checkbox/Checkbox";
import AccessPermissions from "../components/AccessPermissions/AccessPermissions";
import UserEmailAddresses from "../components/UserEmailAddresses/UserEmailAddresses";
import HR from "components/HR/HR";
import Button from "components/Button/Button";
import { submitAddUserFormAction, submitAddOfficerFormAction, loadOrgSiteDeptAction, loadRolesAction, createUsersBulkAction } from "store/actions/Actions";
import { toggleDropdowns } from "helpers/utils";

import { generateOrgList, getInitState, getItemsList } from "../accessUtils";

const Add = props => {
  const { CreateUsersBulkReducer, RolesReducer, loadOrgSiteDeptAction, createUsersBulkAction, loadRolesAction, OrgSiteDeptReducer, UserOrgSiteReducer } = props;
  const [emails, setEmails] = useState('');
  const [stateErrors, setStateErrors] = useState({});
  const history = useHistory();

  const steps = [
    `Select Access Permissions for the Users you wish to notify of the requirement to register. Selections apply to all Users included in the next step, but may be edited later.`,
    `Paste a list of User email addresses (comma separated). Users will be notified via email of their requirement to register once you click "Save".`,
    `Click "Save"`
  ];
  
  useEffect(() => {
    if (!RolesReducer.roles) {
      loadRolesAction();
    }
  }, [RolesReducer.roles, loadRolesAction]);

  useEffect(() => {
    if (!OrgSiteDeptReducer.organizations) {
      loadOrgSiteDeptAction();
    }
  }, [OrgSiteDeptReducer.organizations, loadOrgSiteDeptAction]);

  const orgList = [];
  if (OrgSiteDeptReducer.organizations) {
    let keyId = 0;
    Object.values(OrgSiteDeptReducer.organizations).forEach((org, idx) => {
      keyId = keyId + 1;
      orgList.push({ key: keyId, id: org.id, name: org.name, sites: [] });
      org.sites && Object.values(org.sites).forEach((site, idz) => {
        keyId = keyId + 1;
        orgList[idx]['sites'].push({ key: keyId, id: site.id, name: site.name, deps: [] });
        Object.entries(site.departments).forEach((dep) => {
          keyId = keyId + 1;
          orgList[idx]['sites'][idz]['deps'].push({ key: keyId, id: dep[0], name: dep[1] });
        });
      });
    });
  }
  
  function validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  }

  const handleSubmitAddBulkForm = (e) => {
    try {
      e.preventDefault();
      const access = [];
      let errorAccess = false;
      let errorDepartment = false;
      const rolesElemnets = document.querySelectorAll("[name=role]");
      if (rolesElemnets.length < 1) {
        errorAccess = true;
      }
      rolesElemnets.forEach(item => {
        if (item.value === "0") {
          errorAccess = true;
        }
        access.push({
          role_id: item.value,
          organization: item.dataset.org,
          site: item.dataset.site || null,
          department: item.dataset.dep || (item.dataset.partial === "true" && "partial") || null,
        });
      });
      let errorEmails = false;
      let emails_string = document.querySelector("[name=users-emails]").value;
      // remove whitespace
      emails_string = emails_string.replace(/\s+/g, ',');
      emails_string = emails_string.replace(/\n/g, ',');
      emails_string = emails_string.replace(/,+/g, ',');
      emails_string = emails_string.replace(/,\s*$/, '');
      const emails = emails_string.split(',');
      emails.forEach(email => {
        if (!validateEmail(email)) {
          errorEmails = true;
        }
      });

      // const userRoleId = RolesReducer.roles.filter(role => role.name.includes("User"))[0].id || "";
      // const partials = access.filter(elem => (elem.department === "partial" && elem.role_id === userRoleId)) || [];
      // // foreach user partial, check for childrens, if any of partial does not have children it's error // all site for user should have at least one dep selected
      // partials.forEach(partial => {
      //   const total_departments = access.filter(acc => acc.site === partial.site).length || 0;
      //   if (total_departments < 2) {
      //     errorAccess = true;
      //     errorDepartment = true;
      //   }
      // });

      if (errorAccess || errorEmails) {
        setStateErrors((s) => ({
          ...s,
          access: errorAccess ? (errorDepartment ? "At least one department per site is required!" : "Access role(s) are required!") : "",
          emails: errorEmails ? "Error with emails": "",
        }));
      } else {
        createUsersBulkAction({ access, emails });
      }
    } catch (error) {
      console.log('error submitting bulk form');
    }
  }

  const [localBoxes, setLocalBoxes] = useState({});

  const orgs = generateOrgList(OrgSiteDeptReducer.organizations);
  const items = getItemsList(orgs);
  const initState = { ...getInitState({}, items, RolesReducer.roles), ...localBoxes };

  const stateDropdownRef = React.createRef();

  if (CreateUsersBulkReducer && CreateUsersBulkReducer.message){
    return (
    <Modal
        className={modalStyles.modal}
        setShowModal={true}
        disableCloseButton={true} >
    <div>
      <p className={modalStyles["modal-heading"]}>Results:</p>
        <div className={modalStyles["modal-content"]}>
            {CreateUsersBulkReducer.message.split('\\n').map((str, key) => <div key={key}>{str}</div>)}
        </div>

        <div className={modalStyles["modal-footer"]}>
            <Button
                text="OK"
                color="primary"
                className={styles.create}
                onClick={() => history.push('/maintain/users')}
            />
        </div>
    </div>
</Modal>)
  }

  return (
    <AppLayoutWrapFull 
      onClick={toggleDropdowns([
        stateDropdownRef
      ])}
    >
      <PageHeader showStats={false} />
      <Container>
        <form className={styles["add-user-form"]}>

          <div className={styles.holder}>
            <div className={styles.left}>
              <MessageBox
                boldedText="Step One: "
                className={styles["step-one-box"]}
                text={steps[0]}
              />

              <AccessPermissions
                // className={styles["access-permissions"]}
                // options={orgList}
                // error={stateErrors.access}
                // setStateErrors={setStateErrors}
                // roles={RolesReducer.roles}
                // placeholder="The Business Company"
                className={styles["access-permissions"]}
                organizations={OrgSiteDeptReducer.organizations}
                initState={initState}
                orgs={orgs}
                userOrgs={UserOrgSiteReducer.organizations}
                selected={UserOrgSiteReducer.selected}
                setLocalBoxes={setLocalBoxes}
                loadOrgSiteDeptAction={loadOrgSiteDeptAction}
                roles={RolesReducer.roles}
                error={stateErrors.access}
                setStateErrors={setStateErrors}
                placeholder="The Business Company"
              />
            </div>

            <div className={styles.right}>
              <MessageBox
                boldedText="Step Two: "
                className={styles["step-two-box"]}
                text={steps[1]}
              />
              <UserEmailAddresses
                state={emails}
                error={stateErrors.emails}
                setStateErrors={setStateErrors}
                setState={setEmails}
              />

              <MessageBox
                boldedText="Step Three: "
                className={styles["step-three-box"]}
                text={steps[2]}
              />
            </div>
          </div>
          <HR className={styles.hr} />

          <div className={styles["submit-box"]}>
            <Button text="Cancel" color="secondary" onClick={() => history.push('/maintain/users')} />
            <Button 
              icon="far fa-save" 
              text="Save"
              onClick={handleSubmitAddBulkForm} />
          </div>

        </form>
      </Container>
    </AppLayoutWrapFull>
  );
};

const mapStateToProps = ({ CreateUsersBulkReducer, AddUserFormReducer, UserOrgSiteReducer, AddOfficerFormReducer, OrgSiteDeptReducer, RolesReducer }) => {
  return {
    AddUserFormReducer,
    AddOfficerFormReducer,
    UserOrgSiteReducer,
    OrgSiteDeptReducer,
    RolesReducer,
    CreateUsersBulkReducer
  }
}

const mapDispatchToProps = {
  submitAddUserFormAction,
  submitAddOfficerFormAction,
  loadOrgSiteDeptAction,
  loadRolesAction,
  createUsersBulkAction,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Add);
